module.exports = __webpack_public_path__ + "static/media/sendMessageBlackIcon.5392c549.svg";